// components/Tabs.tsx
import React, { useState } from 'react';
import { SearchTabContent } from './SearchTabContent';
import { TabContent } from './TabContent';
import { useBuilderContext } from '../context/BuilderContext';

const tabConfigs = [
    { label: 'Nifty', scrip: 'NIFTY' },
    { label: 'Bank Nifty', scrip: 'BANKNIFTY' },
    { label: 'Fin Nifty', scrip: 'FINNIFTY' },
    { label: 'Sensex', scrip: 'SENSEX' },
    { label: 'Search', scrip: '' },
];

export default function Tabs() {
    const [searchScrip, setSearchScrip] = useState('');
    const { allSymbols, setSelectedSymbol, selectedSymbol, activeTab, setActiveTab } = useBuilderContext();

    const isSearchTab = activeTab === 'Search';
    const currentScrip = isSearchTab
        ? searchScrip
        : tabConfigs.find((tab) => tab.label === activeTab)?.scrip || '';

    const handleTabClick = (label) => {
        setActiveTab(label);
        if (label !== 'Search') {
            setSearchScrip('');
            const scrip = tabConfigs.find((tab) => tab.label === label)?.scrip;
            const symbol = allSymbols?.find((s) => s.scrip === scrip);
            if (symbol) setSelectedSymbol(symbol);
        }
    };

    return (
        <div className="w-full">
            <div className="flex text-gray-500 text-sm font-medium">
                {tabConfigs.map(({ label }) => (
                    <div
                        key={label}
                        onClick={() => handleTabClick(label)}
                        className={`px-4 py-2 cursor-pointer ${activeTab === label
                            ? 'text-p300 bg-p400 border-gray-200 rounded-t-md font-semibold z-10'
                            : 'hover:text-p300'
                            }`}
                    >
                        {label}
                    </div>
                ))}
            </div>

            <div className="">
                {isSearchTab ? (
                    <SearchTabContent searchScrip={searchScrip} setSearchScrip={setSearchScrip} />
                ) : (
                    <TabContent symbol={selectedSymbol} />
                )}
            </div>
        </div>
    );
}
